import { selectHintsState } from './selectHintsState';
var selectIsCookiesConsentHintEnabled = function (state) {
    return selectHintsState(state).isCookiesConsentHintEnabled;
};
export { selectIsCookiesConsentHintEnabled };
